import React, { useRef, useState, useEffect } from "react";
import { FormikProvider, useFormik } from "formik";
import { Link } from "react-router-dom";
import { post } from "../../../helpers/api_helper";
import ReactApexChart from "react-apexcharts";
import { Spin } from "antd";
import { POST_GetTopTestsData } from "../../../helpers/url_helper";

import * as echarts from "echarts";

const TopTests = () => {
  const [isLoading, setIsLoading] = useState(false);
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const formik = useFormik({
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      DayType: 1,
      TopTestList: [],
      TestNames: [],
      TestingCounts: [],
      PeriodType: 1,
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmit,
    values: { DayType, TopTestList, TestNames, TestingCounts, PeriodType },
  } = formik;

  useEffect(() => {
    getTopTestsDetails(1);
  }, []);

  const getTopTestsDetails = async (typeid) => {
    formik.setFieldValue("PeriodType", typeid);
    setIsLoading(true);

    let payload = {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      PeriodType: typeid,
    };

    await post(POST_GetTopTestsData, payload)
      .then((response) => {
        bindChartData(response?.List);
        formik.setFieldValue("TopTestList", response?.List);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const bindChartData = (list) => {
    let testNamesArray = [],
      testingCountArray = [];

    Promise.all(
      list?.map((x) => {
        testNamesArray.push(x.TestName);
        testingCountArray.push(x.TestingCount);
      })
    );

    formik.setFieldValue("TestNames", testNamesArray);
    formik.setFieldValue("TestingCounts", testingCountArray);
  };

  const chartRef = useRef();

  useEffect(() => {
    const myChart = echarts.init(chartRef.current);

    const options = {
      tooltip: {
        trigger: "item",
        formatter: "{b} <br/>Testing Count : {c}",
      },
      // legend: {
      //   top: "5%",
      //   left: "center",
      // },
      series: [
        {
          name: "",
          type: "pie",
          radius: ["40%", "70%"],
          center: ["50%", "50%"],
          startAngle: 180,
          endAngle: 360,
          data: TopTestList.map((item) => ({
            name: item.TestName + " - " + item.TestingCount,
            value: item.TestingCount,
          })),
          label: {
            color: "inherit",
          },
        },
      ],
      grid: {
        left: 20,
        top: 20,
        right: "5%",
        bottom: "5%",
      },
    };

    myChart.setOption(options);

    // Clean up the chart instance
    return () => {
      myChart.dispose();
    };
  }, [TopTestList]);

  return (
    <>
      <Spin size="large" spinning={isLoading} tip={"Loading..."}>
        <div className="card mb-2" style={{ height: "calc(100% - 10px)" }}>
          <div className="card-body p-0">
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0 ps-2">Top Tests</h4>
                <FormikProvider value={formik}>
                  <form onSubmit={formik.handleSubmit}>
                    <div className="d-flex align-items-center">
                      <Link
                        title="Current Year"
                        className={`btn ${
                          PeriodType == 1
                            ? "btn-primary"
                            : "btn-outline-primary"
                        } btn-sm`}
                        onClick={(e) => {
                          getTopTestsDetails(1);
                        }}
                      >
                        CY
                      </Link>
                      &nbsp;
                      <Link
                        title="Current Month"
                        className={`btn ${
                          PeriodType == 2
                            ? "btn-primary"
                            : "btn-outline-primary"
                        } btn-sm`}
                        onClick={(e) => {
                          getTopTestsDetails(2);
                        }}
                      >
                        CM
                      </Link>
                      &nbsp;
                      <Link
                        title="Previous Month"
                        className={`btn ${
                          PeriodType == 3
                            ? "btn-primary"
                            : "btn-outline-primary"
                        } btn-sm`}
                        onClick={(e) => {
                          getTopTestsDetails(3);
                        }}
                      >
                        PM
                      </Link>
                    </div>
                  </form>
                </FormikProvider>
              </div>
              <div>
                <div
                  ref={chartRef}
                  style={{ width: "100%", height: "400px" }}
                ></div>
              </div>
              {/* <div
                  id="donut-chart-container"
                  style={{ width: "100%", height: "400px" }}
                ></div> */}
              {/* <div>
                  <HighchartsReact highcharts={Highcharts} options={options} />
                </div> */}
              {/* <div>
                  <ReactApexChart
                    options={options}
                    series={series}
                    type="pie"
                    height={300}
                  />
                </div> */}
            </div>
          </div>
        </div>
      </Spin>
    </>
  );
};

export default TopTests;
